import { parseYouTubeVideoId, toYouTubeEmbedUrl } from "@/lib/youtube";

type YouTubeEmbedProps = {
  url: string;
  title?: string;
  className?: string;
};

export default function YouTubeEmbed({ url, title = "YouTube video", className = "" }: YouTubeEmbedProps) {
  const videoId = parseYouTubeVideoId(url);
  if (!videoId) return null;

  return (
    <div className={`relative w-full ${className}`} style={{ paddingBottom: "56.25%" }}>
      <iframe
        src={toYouTubeEmbedUrl(videoId)}
        title={title}
        className="absolute inset-0 w-full h-full rounded-lg"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
}
